module.exports = __webpack_public_path__ + "24732aac6526f4295846dd620dc2bfb1.png";